import ProductStar from './ProductStar/ProductStar';
import './ProductRating.css';

function ProductRating({id, rating, reviewCount}) {
    const MAX_RATING = 5;

    const getRating = () => {
        return rating > MAX_RATING ? MAX_RATING : rating;
    };

    const getPercentage = () => {
        return Math.max(0, Math.min(getRating() / MAX_RATING, 1)) * 100;
    };

    const getFill = (index) => {
        const split = 100 / MAX_RATING;
        const rangeStart = (index - 1) * split;
        const _rating = getPercentage();
        const subrating = _rating - rangeStart;
        let fill = Math.round((subrating * 100) / split);
        fill = fill > 100 ? 100 : fill;
        fill = fill < 0 ? 0 : fill;
        return fill;
    };

    const renderStars = () => {
        return Array.from({length: MAX_RATING}).map((_, i) => {
            const fill = getFill(i + 1);
            return <ProductStar key={`product-rating-star-${id}-${i}`} id={id} index={i} fill={fill}/>;
        });
    };

    return (
        <div className='product-rating'>
            {renderStars()}
            <span className='product-rating-review-count'>({reviewCount})</span>
        </div>
    );
}

export default ProductRating;